"use client";
import React from "react";
import { Box, Text } from "rizzui";
import HeadsetIcon from "../assets/headset";
import UserIcon from "../assets/user";
import { formatDuration } from "../lib/utils/formatDate";

export default function TranscriptTabContent({ transcript, row, callStatus }) {
  return (
    <Box className="flex flex-col gap-[24px]">
      {transcript?.length > 0 ? (
        transcript?.map((message, index) => (
          <Box key={index}>
            <Box className="flex gap-[8px]">
              {message?.role === "bot" && (
                <Box className="size-[36px] bg-[#CEE7FF] rounded-[8px] !rounded-tl-none flex items-center justify-center">
                  <HeadsetIcon className={"text-[#191919] "} />
                </Box>
              )}
              {message?.role === "user" && (
                <Box className="size-[36px] bg-[#758599] rounded-[8px] !rounded-tl-none flex items-center justify-center">
                  <UserIcon
                    className={"text-background dark:text-primary-dark"}
                  />
                </Box>
              )}
              <Box>
                <Text className="font-switzer font-[500] text-[14px] text-primary-dark">
                  {message?.role === "bot"
                    ? "Your assistant"
                    : row?.original?.lead_details?.firstname}
                </Text>
                <Text className="font-switzer font-[400] text-[12px] text-[#758599]">
                  {formatDuration(message?.secondsFromStart)} sec
                </Text>
              </Box>
            </Box>
            <Text className="font-switzer mt-2 ml-[44px] font-[400] text-[12px] text-primary-dark">
              {message?.message}
            </Text>
          </Box>
        ))
      ) : (
        <Text className="font-switzer text-[12px] dark:text-[#758599] font-[500] mx-auto">
          {callStatus === "completed"
            ? "Not Available"
            : "The transcript of the call will appear here once the call is completed."}
        </Text>
      )}
    </Box>
  );
}
